<template lang='pug'>
  el-upload(
    action=""
    :file-list="fileList"
    :multiple="false"
    :auto-upload="false"
    :on-change="handleChange"
    :on-remove="handleRemove"
    :disabled="isDisabled"
  ).avatar-uploader.pos-r.of-h.size-100
    .pin.pin-xy
      avatar(:imageUrl="imageUrl" icon-size="7x").size-100
      .pic-btn-wrap
        el-button(
          circle
          :type="isDisabled ? '' : 'primary'"
          icon="el-icon-camera"
          :disabled="isDisabled"
        ).btn-lg-icon
</template>

<script>
import resizeImage from '@/plugins/image-resize';
import Avatar from './Avatar.vue';

export default {
  name: 'AvatarUploader',
  components: { Avatar },

  props: {
    imageUrl: { default: '', type: String },
    isDisabled: { default: false, type: Boolean },
  },

  data() {
    return {
      fileList: [],
      selectedFile: null,
    };
  },

  methods: {
    handleChange(file, fileList) {
      const fileRaw = file.raw;
      const isLt50M = file.size / 1024 / 1024 < 50;

      if (!isLt50M) {
        this.$message.error('Avatar picture size can not exceed 2MB!');
      } else {
        if (fileList.length > 1) {
          fileList.shift();
        }

        this.fileFlag = true;

        resizeImage({ file: fileRaw, maxSize: 400 })
          .then((resizedImage) => {
            this.selectedFile = resizedImage;
            this.$emit('fileSelected', {
              selectedFile: this.selectedFile,
              image: URL.createObjectURL(resizedImage),
            });
          }).catch((err) => {
            console.error(err);
          });
      }
    },

    handleRemove() {
      // available aurgs: file, fileList
      this.fileFlag = false;
    },
  },
};
</script>
